import React, { useState } from 'react';
import { Input } from 'antd';
import './Home.css';
import { Link } from 'react-router-dom';
import { CriblLogoIcon, TutorialIcon } from './svg';
import { Navbar } from './Navbar';
import { Header } from './Header';
import * as config from './config';


const { Search } = Input;

declare global {
  interface Window {
    courses: Array<ICourseInfo>;
  }
}

export interface OutlineItem {
  type: 'group' | 'item';
  id: string;
  label: string;
  content?: string;
}

export interface ICourseInfo {
  id: string;
  title: string;
  duration: string;
  description: string;
  outline: OutlineItem[];
  overview: string;
  imageUrl: string;
  imageWidth?: string;
  type:'course' | 'tutorial';
  startupTime?: number;
}



const CourseBox = (props: { course:ICourseInfo }) => {
  return (
    <Link to={`/course/${props.course.id}`}>
      <div className='course-box'>
        <div className='course-box__top-box'>
          <div className='course-box__image' style={{backgroundImage:`url(${props.course.imageUrl})`}}></div>
        </div>
        <div className='course-box__bottom-box'>
          <div className='course-box__title'>{props.course.title}</div>
          <div className='course-box__time'>{props.course.duration}</div>
        </div>
      </div>
    </Link>
  );
}

const TutorialBox = (props: { course:ICourseInfo }) => {
  return (
    <Link to={`/course/${props.course.id}`}>
      <div className='tutorial-box'>
        <div className='tutorial-box__top-box'>
          <div className='tutorial-box__image'>
            <TutorialIcon height={25} />
          </div>
        </div>
        <div className='tutorial-box__bottom-box'>
          <div className='tutorial-box__title'>{props.course.title}</div>
          <div className='tutorial-box__time'>{props.course.duration}</div>
        </div>
      </div>
    </Link>
  );
}

const DemoBox = (props: { course:ICourseInfo }) => {
  return (
    <Link to={`/course/${props.course.id}`}>
      <div className='tutorial-box'>
        <div className='tutorial-box__top-box'>
          <div className='tutorial-box__image'>
            <TutorialIcon height={25} />
          </div>
        </div>
        <div className='tutorial-box__bottom-box'>
          <div className='tutorial-box__title'>{props.course.title}</div>
          <div className='tutorial-box__time'>{props.course.duration}</div>
        </div>
      </div>
    </Link>
  );
}

const searchCourses = (courses: ICourseInfo[], query: string) => {
  return courses.filter(course => course.title.toLowerCase().includes(query.toLowerCase()));
};

export const Home = () => {
  const [search, setSearch] = useState('');
  const courses = (window.courses || []).filter(c => c.type==='course')
  const tutorials = (window.courses || []).filter(c => c.type==='tutorial');
  const demos = (window.courses || []).filter(c => c.type==='demo');
  const showSearch = courses.length > 8 || tutorials.length > 8;
  const filteredCourses = showSearch ? searchCourses(courses, search) : courses;
  const filteredTutorials = showSearch ? searchCourses(tutorials, search) : tutorials;
  const filteredDemos = showSearch ? searchCourses(demos, search) : demos;
  const fromDemo = config.demoHosts.includes(window.location.hostname);
  console.log(`Hostname Location: ${window.location.hostname}`);
  return (
    <div>
      <Navbar />
      <Header
        description={
          <div>
            <h1>Stream Sandbox</h1>
            <p>Welcome! Sandboxes are online courses to help you learn about Stream. </p>
            <p>We recommend you start with Stream Fundamentals, which covers basic product usage and includes a tour of many common use cases. If you have questions, please find us in our <a href='https://cribl.io/community'>Community Slack.</a></p>
          </div>
        }
        imageComponent={
          <CriblLogoIcon height={250} className="home__header-icon" />
        }
      />

      <div className="wrapped">
        {
          showSearch &&
          <div className="home__search">
            <Search placeholder="Search by keyword" value={search} onChange={e => setSearch(e.target.value)} enterButton style={{ width: 300 }}/>
          </div>
        }
        { !fromDemo && 
        <div className="home__courses-section">
          <h2 className="home__tiles-title">Courses</h2>
          <p className="home__tiles-subtitle">These award a completion certificate</p>
          <div className="home__tiles home__tiles--courses">
            { filteredCourses.map(c => <CourseBox key={c.id} course={c} /> )}
            { filteredCourses.length === 0 && <div className="home__no-results">No courses found</div> }
          </div>
        </div>
        }
        { !fromDemo && 
        <div className="home__courses-section">
          <h2 className="home__tiles-title">Tutorials</h2>
          <p className="home__tiles-subtitle">These quick how-to's take as little as a few minutes</p>
          <div className="home__tiles home__tiles--tutorials">
            { filteredTutorials.map(t => <TutorialBox key={t.id} course={t} /> )}
            { filteredTutorials.length === 0 && <div className="home__no-results">No tutorials found</div> }
          </div>
        </div>
        }
        { fromDemo && 
        <div className="home__courses-section">
          <h2 className="home__tiles-title">Demos</h2>
          <p className="home__tiles-subtitle">On-Demand Demo Environments</p>
          <div className="home__tiles home__tiles--tutorials">
            { filteredDemos.map(t => <DemoBox key={t.id} course={t} /> )}
            { filteredDemos.length === 0 && <div className="home__no-results">No tutorials found</div> }
          </div>
        </div>
        }
      </div>
    </div>
  );
};

